import { BaseApi } from '../baseApi';
import type { OpportunityDetailResponse, AIMatchAssessment } from '@/types/models';
import type { APIResponse } from '../config';

export class OpportunityApi extends BaseApi {
  async getOpportunities(): Promise<OpportunityDetailResponse[]> {
    const response = await this.makeGet<APIResponse<OpportunityDetailResponse[]>>('/opportunities');
    return response.data;
  }

  async getOpportunityDetail(id: number): Promise<OpportunityDetailResponse> {
    const response = await this.makeGet<APIResponse<OpportunityDetailResponse>>(`/opportunities/${id}`);
    return response.data;
  }

  async getOpportunityAIMatch(id: number): Promise<AIMatchAssessment> {
    const response = await this.makeGet<APIResponse<AIMatchAssessment>>(`/opportunities/${id}/ai-match`);
    return response.data;
  }

  // Helper method to get cache key
  static getOpportunityQueryKey(id: string | number | null | undefined) {
    if (!id) return ['opportunity'];
    return ['opportunity', typeof id === 'string' ? id : id.toString()];
  }

  // Helper method to get application check cache key
  static getApplicationCheckQueryKey(id: string | number | null | undefined) {
    if (!id) return ['application-check'];
    return ['application-check', typeof id === 'string' ? id : id.toString()];
  }
} 